var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-message"
  }, [_vm._t("default"), _vm.props.messageItem.status === 'unSend' && _vm.props.messageItem.progress < 1 ? _c('div', {
    staticClass: "progress-container"
  }, [_c('progress', {
    staticClass: "progress",
    attrs: {
      "max": "1"
    },
    domProps: {
      "value": _vm.props.messageItem.progress
    }
  })]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }